"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSGameScene = void 0;
const Game_1 = require("./Game");
const KHInputProvider_1 = require("./KH/Input/KHInputProvider");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHRandom_1 = require("./KH/KHRandom");
const TSBlock_1 = require("./TSBlock");
const TSGrid_1 = require("./TSGrid");
const TSOptions_1 = require("./TSOptions");
class TSGameScene extends Phaser.Scene {
    constructor() {
        super("TSGameScene");
    }
    blocksAt(x, y) {
        return this.grid.at(x, y);
    }
    getControlledBlock() {
        return this.controlledBlock;
    }
    create() {
        this.audio_scene = Game_1.game_manager.add_or_get_audio_scene(this);
        this.controller = Game_1.game_manager.getController();
        this.controller.register(KHInputScene_1.KHInputScene.SharedInput);
        this.add.sprite(0, 0, 'table').setOrigin(0);
        this._board = this.add.sprite(0, 0, 'board').setOrigin(0);
        this.grid = new TSGrid_1.TSGrid(7, 7, 10);
        this._movementAllowed = false;
        this._moveSounds = [
            this.sound.add('move1'),
            this.sound.add('move2'),
            this.sound.add('move3'),
            this.sound.add('move4'),
            this.sound.add('move5'),
            this.sound.add('move6'),
        ];
        this._badMoveSounds = [
            this.sound.add('move_bad1'),
            this.sound.add('move_bad2'),
        ];
        this._loseSound = this.sound.add('lose', { volume: 0.5 });
        this._dealSound = this.sound.add('deal');
        this._winSound = this.sound.add('win');
        this._deadMoveSound = this.sound.add('move_death');
        this._woodSlideSound = this.sound.add('wood_slide', { volume: 0.5 });
        this.loadNextLevel();
    }
    loadNextLevel() {
        var _a, _b;
        const levels = Game_1.game_manager.getGames();
        const currentLevel = TSOptions_1.global_save.level.get();
        if (currentLevel >= levels.length) {
            (_a = this._woodSlideSound) === null || _a === void 0 ? void 0 : _a.play();
            this.tweens.add({
                targets: this._board,
                x: 64,
                duration: 750,
                ease: Phaser.Math.Easing.Sine.In,
                onComplete: () => {
                    this.scene.start("TSEndScene", null);
                }
            });
            return;
        }
        const level = levels[currentLevel];
        TSOptions_1.global_save.level.set(currentLevel + 1);
        this.startLevel(level());
        (_b = this._dealSound) === null || _b === void 0 ? void 0 : _b.play();
    }
    startLevel(level) {
        // console.log(level)
        this.placedBlocks = 0;
        this.controlledBlockArr = [];
        this.controlledBlock = null;
        this._game = level;
        this._game.gameInterface = this;
        this._game.onStart(this);
        this.time.addEvent({
            delay: 50 * this.placedBlocks + 750,
            callback: () => {
                this._movementAllowed = true;
            }
        });
    }
    goToNextControlledBlock(killCurrent) {
        if (killCurrent) {
            this.controlledBlock.kill();
        }
        if (this.controlledBlockArr.length == 0) {
            return null;
        }
        else {
            const newBlock = this.controlledBlockArr.shift();
            this.setControlledBlock(newBlock);
            return newBlock;
        }
    }
    addBlock(block, x, y, controlled) {
        this.addToGrid(block, x, y);
        if (controlled) {
            if (this.controlledBlock != null) {
                this.controlledBlockArr.unshift(this.controlledBlock);
            }
            this.setControlledBlock(block);
        }
    }
    addBlockNoAnim(block, x, y) {
        this.addToGrid(block, x, y, false);
    }
    swap(block, x, y) {
        this.grid.swapWith(block, x, y);
    }
    lose() {
        const killTime = this.controlledBlock.kill();
        this._movementAllowed = false;
        const betweenDelay = 30;
        this.time.addEvent({
            delay: killTime,
            callback: () => {
                var _a;
                const all = this.grid.allPieces();
                new KHRandom_1.KHRandomGeneral().shuffleArray(all);
                for (let i = 0; i < all.length; i++) {
                    all[i].kill(betweenDelay * i);
                }
                this.time.addEvent({
                    delay: all.length * betweenDelay + killTime + 500,
                    callback: () => {
                        this.modeEnded(false);
                    }
                });
                (_a = this._loseSound) === null || _a === void 0 ? void 0 : _a.play();
            }
        });
    }
    win() {
        this._movementAllowed = false;
        const betweenDelay = 30;
        const all = this.grid.allPieces();
        new KHRandom_1.KHRandomGeneral().shuffleArray(all);
        let highestPos = 0;
        for (let i = 0; i < all.length; i++) {
            const pos = all[i].pos.x + all[i].pos.y;
            all[i].celebrate(pos * betweenDelay, true);
            highestPos = Math.max(pos, highestPos);
        }
        this.time.addEvent({
            delay: 1000,
            callback: () => { var _a; return (_a = this._winSound) === null || _a === void 0 ? void 0 : _a.play(); }
        });
        this.time.addEvent({
            delay: highestPos * betweenDelay + 1000 + 500,
            callback: () => {
                this.modeEnded(true);
            }
        });
    }
    modeEnded(win) {
        if (win)
            TSOptions_1.global_save.wins.set(TSOptions_1.global_save.wins.get() + 1);
        this.placedBlocks = 0;
        this.loadNextLevel();
    }
    addToGrid(block, x, y, anim = true) {
        this.add.existing(block);
        block.addToGrid(this.grid, x, y);
        if (anim)
            block.animateIn(this.placedBlocks * 50);
        this.placedBlocks++;
        return block;
    }
    setControlledBlock(block) {
        var _a;
        (_a = this.controlledBlock) === null || _a === void 0 ? void 0 : _a.setSelected(false);
        this.controlledBlock = block;
        block.setSelected(true);
        block.setDepth(1);
    }
    update(time, delta) {
        if (this._movementAllowed && this.controlledBlock) {
            if (this.controller.getInput(Game_1.Controls.Up).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Up);
            }
            else if (this.controller.getInput(Game_1.Controls.Down).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Down);
            }
            else if (this.controller.getInput(Game_1.Controls.Right).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Right);
            }
            else if (this.controller.getInput(Game_1.Controls.Left).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Left);
            }
        }
    }
    moveOffset(dir) {
        var _a, _b, _c, _d;
        this._game.onWillMove(this.controlledBlock);
        const block = this.controlledBlock;
        const offset = TSBlock_1.TSBlockMoving.OffsetForDir(dir);
        const start = [this.controlledBlock.pos.x, this.controlledBlock.pos.y];
        const desired = [this.controlledBlock.pos.x + offset[0], this.controlledBlock.pos.y + offset[1]];
        const moved = this.grid.tryMoveTo(this.controlledBlock, dir);
        this._game.onDidMove(this.controlledBlock, start, desired, moved);
        if (block.isDead()) {
            (_a = KHInputProvider_1.KHInputProvider.lastInputSource) === null || _a === void 0 ? void 0 : _a.tryVibrate(100, 0, 0.3);
            (_b = this._deadMoveSound) === null || _b === void 0 ? void 0 : _b.play();
        }
        else if (moved) {
            (_c = KHInputProvider_1.KHInputProvider.lastInputSource) === null || _c === void 0 ? void 0 : _c.tryVibrate(20, 0.1, 0);
            new KHRandom_1.KHRandomGeneral().getRandom(this._moveSounds).play();
        }
        else {
            (_d = KHInputProvider_1.KHInputProvider.lastInputSource) === null || _d === void 0 ? void 0 : _d.tryVibrate(20, 0.3, 0);
            new KHRandom_1.KHRandomGeneral().getRandom(this._badMoveSounds).play();
        }
    }
}
exports.TSGameScene = TSGameScene;
